import React from "react";
import { withRouter } from "react-router";
import LayoutPage from "../Layout/LayoutPage";
import routeMapTable from "../config/routeMapTable";
import PropTypes from "prop-types";

const GameCategoryPage = ({ match, history }) => {
    const category = match.params.category;
    const gameid = match.params.gameid;
    const game = routeMapTable[category];

    if (!gameid && game) {
        return <LayoutPage categories={game.categories} title={game.title} />;
    } else {
        history.push("/");
        return null;
    }
};

GameCategoryPage.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
};

export default withRouter(GameCategoryPage);
